<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <div class="table-responsive">
          <table class="table table-striped table-bordered">
            <thead>
              <tr>
                <th>Item</th>
                <th>Vai ter cálculo?</th>
                <th>Quantidade por vez?</th>
                <th>Quantas vezes ao dia?</th>
                <th>Quantos dias de estoque mínimo?</th>
                <th>Estoque mínimo</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in answer" :key="index">
                <td>
                  <span v-if="item.product_id">{{ item.product_name }}</span>
                  <span v-if="item.medicine_id">{{ item.medicine_name }}</span>
                  <input
                    placeholder="Observação"
                    type="text"
                    class="form-control form-control-sm"
                    v-model="item.note"
                  />
                </td>
                <td>
                  <select
                    v-model="item.calculation"
                    class="form-control form-control-sm"
                  >
                    <option value="1">SIM</option>
                    <option value="0">NÃO</option>
                  </select>
                </td>
                <td>
                  <input
                    v-show="item.calculation == 1"
                    type="text"
                    class="form-control form-control-sm"
                    v-model="item.quantity"
                    @input="calculation"
                  />
                </td>
                <td>
                  <input
                    v-show="item.calculation == 1"
                    type="number"
                    class="form-control form-control-sm"
                    v-model="item.how_many_times"
                    @input="calculation"
                  />
                </td>
                <td>
                  <input
                    v-show="item.calculation == 1"
                    type="number"
                    class="form-control form-control-sm"
                    v-model="item.days_minimum_stock"
                    @input="calculation"
                  />
                </td>
                <td>
                  <div class="input-group">
                    <input
                      type="text"
                      class="form-control form-control-sm"
                      v-model="item.minimum_stock"
                      :disabled="item.calculation == 1"
                    />
                    <div class="input-group-pprend">
                      <button
                        type="button"
                        class="btn btn-sm btn-light"
                        v-if="item.product_id"
                      >
                        {{ item.product_unit_of_measurement_abbreviation }}
                      </button>
                      <button
                        type="button"
                        class="btn btn-sm btn-light"
                        v-if="item.medicine_id"
                      >
                        {{ item.medicine_unit_of_measurement_abbreviation }}
                      </button>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <ErrorsMessages :errors="errors" />
    <div class="row">
      <div
        class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 check-text-center"
      >
        <confirmation-dialog
          :disabled="loading"
          message-title="CANCELAR?"
          header-class="modal-header-red"
          yesClass="btn-delete worksansr"
          message-body="Tem certeza que deseja cancelar? Não é possível retornar."
          open-text="CANCELAR"
          open-class="btn-cancel m-1"
          @yes="$emit('return')"
        />
      </div>
      <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 check-text-right">
        <strong v-if="total > 1" class="text-fifteen upper-text p-2 m-1">
          {{ current + 1 }} de {{ total }} residentes</strong
        >
        <confirmation-dialog
          :disabled="loading"
          message-title="Enviar formulário?"
          message-body="O formulario será salvo e você ira para o próximo residente."
          :open-text="
            total > 1
              ? current == total - 1
                ? 'CONCLUIR'
                : 'AVANÇAR'
              : 'SALVAR'
          "
          header-class="modal-header-ok"
          yesClass="btn-save worksansr"
          open-class="btn-save m-1"
          open-left-icon="fa-check mr-2"
          @yes="answerQuestions"
        />
      </div>
    </div>
  </div>
</template>

<script>
import api from "../../services/api";

import ErrorsMessages from "../Components/ErrorsMessages";

import toast from "../../lib/ToastNotification";

import ConfirmationDialog from "../Components/ConfirmationDialog.vue";

export default {
  name: "ListWithProps",

  components: {
    ErrorsMessages,
    ConfirmationDialog,
  },

  props: {
    resident: [Object, undefined],
    list: [Object, undefined],
    firstanswer: [Array],
    current: { type: Number, required: true, default: 0 },
    total: { type: Number, required: true, default: 0 },
  },

  watch: {
    resident: function () {
      this.reset().then();
    },
  },

  data() {
    return {
      answer: [],
      errors: [],
      loading: false,
      current_panel: 0,
    };
  },

  created() {
    this.get().then();
  },

  methods: {
    async calculation() {
      for (let item of this.answer) {
        if (item.calculation == 1) {
          item.minimum_stock =
            item.quantity * item.how_many_times * item.days_minimum_stock;
        }
      }
    },
    async get() {
      try {
        this.loading = true;

        let { firstanswer, current } = this;

        let params = {
          id: this.list.id,
          list_item_status: 1,
          verify_resident_list_item: "VERIFICAR",
        };

        let response = await api.get("/rest-home/list", {
          params,
        });

        let { error, errors, list_items } = response.data;
        if (!error) {
          let answer = [];
          for (let list_item of list_items) {
            let calculation = 0;
            let quantity = 1;
            let how_many_times = 1;
            let days_minimum_stock = 1;
            let minimum_stock = 0;
            let note = "";
            if (firstanswer && firstanswer.length > 0 && current > 0) {
              calculation = firstanswer.find(
                (item) => item.id == list_item.id
              ).calculation;
              quantity = firstanswer.find(
                (item) => item.id == list_item.id
              ).quantity;
              how_many_times = firstanswer.find(
                (item) => item.id == list_item.id
              ).how_many_times;
              days_minimum_stock = firstanswer.find(
                (item) => item.id == list_item.id
              ).days_minimum_stock;
              minimum_stock = firstanswer.find(
                (item) => item.id == list_item.id
              ).minimum_stock;
              note = firstanswer.find((item) => item.id == list_item.id).note;
            }

            if (list_item.resident_list_item) {
              calculation = list_item.resident_list_item.calculation;
              quantity = list_item.resident_list_item.quantity;
              how_many_times = list_item.resident_list_item.how_many_times;
              days_minimum_stock =
                list_item.resident_list_item.days_minimum_stock;
              minimum_stock = list_item.resident_list_item.minimum_stock;
              note = list_item.resident_list_item.note;
            }

            answer.push({
              id: list_item.id,
              list_id: list_item.list_id,
              resident_id: this.resident.id,
              product_id: list_item.product_id,
              medicine_id: list_item.medicine_id,
              product_name: list_item.product_name,
              medicine_name: list_item.medicine_name,
              product_unit_of_measurement_abbreviation:
                list_item.product_unit_of_measurement_abbreviation,
              medicine_unit_of_measurement_abbreviation:
                list_item.medicine_unit_of_measurement_abbreviation,
              type: list_item.type,
              calculation,
              quantity,
              how_many_times,
              days_minimum_stock,
              minimum_stock,
              note,
            });
          }
          this.answer = answer;
        } else {
          this.errors = errors;
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    async answerQuestions() {
      try {
        this.loading = true;

        let answerFormatted = this.answer.map((item) => {
          return {
            list_item_id: item.id,
            calculation: item.calculation,
            quantity: item.quantity,
            how_many_times: item.how_many_times,
            days_minimum_stock: item.days_minimum_stock,
            minimum_stock: item.minimum_stock,
            note: item.note,
          };
        });

        let params = {
          resident_id: this.resident.id,
          list_id: this.list.id,
          answer: answerFormatted,
        };
        const response = await api.post("/rest-home/list/answer", params);

        const { error, errors, message } = response.data;

        if (!error) {
          toast(message, "success");
          this.$emit("anwered", {
            answer: this.current == 0 ? this.answer : this.firstanswer,
          });
        } else {
          this.errors = errors;
        }
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    async reset() {
      this.current_panel = 0;
      this.answer = [];
      this.errors = [];
      this.loading = false;

      await this.get();
    },
  },
};
</script>
